export default __webpack_public_path__ + "static/media/bg.aee73404.jpg";